module.exports = __webpack_public_path__ + "img/next-arrow.8fd8c976.svg";